import React from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Kit 2 React components
import { DatePickerCustoms } from "components/DatePickerCustoms";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import MKAlert from "components/MKAlert";
import MKInput from "components/MKInput";

// ultils
import validIdCard from "utils/valid-idcard";
import validMobileNo from "utils/valid-mobileno";
import validCharater from "utils/valid-character";
import validLength from "utils/valid-lenght";
import validDate from "utils/valid-date";
import validNumber from "utils/valid-number";

// api
import { verifyLaserId } from "api/verify";
import { findCustTargetByCitizenIdAndCifNo } from "api/master";
import { addRegister, checkDupEarthQuake, exportCidToDebtTracking } from "api/register";
import { encryptGCM } from "api/crypto";

function FormInformation(props) {
  const navigate = useNavigate();

  const [isAlert, setIsAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("");
  const [alertType, setAlertType] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const [custType, setCustType] = React.useState(null);
  const [citizenId, setCitizenId] = React.useState(null);
  const [validCitizenId, setValidCitizenId] = React.useState(false);

  const [laserCardId, setLaserCardId] = React.useState(null);
  const [validLaserCardId, setValidLaserCardId] = React.useState(false);

  const [name, setName] = React.useState(null);
  const [validName, setValidName] = React.useState(false);

  const [surname, setSurname] = React.useState(null);
  const [validSurname, setValidSurname] = React.useState(false);

  const [dateOfBirth, setDateOfBirth] = React.useState(null);
  const [validBirthtDay, setValidBirthDay] = React.useState(false);

  const [homeNo, setHomeNo] = React.useState("-");
  const [validHomeNo, setValidHomeNo] = React.useState(false);

  const [road, setRoad] = React.useState("-");
  const [validRoad, setValidRoad] = React.useState(false);

  const [subDistrict, setSubDistrict] = React.useState("-");
  const [validSubDistrict, setValidSubDistrict] = React.useState(false);

  const [district, setDistrict] = React.useState("-");
  const [validDistrict, setValidDistrict] = React.useState(false);

  const [province, setProvince] = React.useState("-");
  const [validProvince, setValidProvince] = React.useState(false);

  const [postCode, setPostCode] = React.useState("-");
  const [validPostCode, setValidPostCode] = React.useState(false);

  const [telNo, setTelNo] = React.useState(null);
  const [validTelNo, setValidTelNo] = React.useState(false);

  const [digitNo, setDigitNo] = React.useState(null);
  const [validDigitNo, setValidDigitNo] = React.useState(false);

  const handleChangeCustType = (e) => {
    setCustType(e.target.value);
  };

  const handleChangeCitizenId = (e) => {
    if (custType === "บุคคลธรรมดา") {
      setValidCitizenId(
        !e.target.value || validIdCard(e.target.value) || validLength(e.target.value, 13)
          ? true
          : false
      );
    } else {
      setValidCitizenId(false);
    }
    setCitizenId(e.target.value);
  };
  const handleChangeLaserCardId = (e) => {
    if (custType === "บุคคลธรรมดา") {
      setValidLaserCardId(!e.target.value || validLength(e.target.value, 12));
      setLaserCardId(e.target.value);
    } else {
      setValidLaserCardId(false);
      setLaserCardId("-");
    }
  };
  const handleChangeName = (e) => {
    if (custType === "บุคคลธรรมดา") {
      setValidName(!e.target.value || validCharater(e.target.value));
      setName(e.target.value);
    } else {
      setValidName(false);
      setName(e.target.value);
    }
  };
  const handleChangeSurname = (e) => {
    if (custType === "บุคคลธรรมดา") {
      setValidSurname(!e.target.value || validCharater(e.target.value));
      setSurname(e.target.value);
    } else {
      setValidSurname(false);
      setName("-");
    }
  };
  const handleChangeHomeNo = (e) => {
    setValidHomeNo(!e.target.value ? true : false);
    setHomeNo(e.target.value);
  };
  const handleChangeRoad = (e) => {
    setValidRoad(!e.target.value ? true : false);
    setRoad(e.target.value);
  };
  const handleChangeSubDistrict = (e) => {
    setValidSubDistrict(!e.target.value ? true : false);
    setSubDistrict(e.target.value);
  };
  const handleChangeDistrict = (e) => {
    setValidDistrict(!e.target.value ? true : false);
    setDistrict(e.target.value);
  };
  const handleChangeProvince = (e) => {
    setValidProvince(!e.target.value ? true : false);
    setProvince(e.target.value);
  };
  const handleChangePostCode = (e) => {
    setValidPostCode(
      !e.target.value || validLength(e.target.value, 5) || validNumber(e.target.value)
    );
    setPostCode(e.target.value);
  };
  const handleChangeTelNo = (e) => {
    setValidTelNo(
      !e.target.value || validMobileNo(e.target.value) || validLength(e.target.value, 10)
    );
    setTelNo(e.target.value);
  };
  const handleChangeDigitNo = (e) => {
    setValidDigitNo(validLength(e.target.value, 4));
    setDigitNo(e.target.value);
  };

  const handleConfirmRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (
      !citizenId ||
      !name ||
      (!surname && custType === "บุคคลธรรมดา") ||
      (!dateOfBirth && custType === "บุคคลธรรมดา") ||
      !telNo ||
      !digitNo
    ) {
      setIsLoading(false);
      setIsAlert(true);
      setAlertMsg("กรุณาระบุข้อมูลให้ครบถ้วน หรือถูกต้อง");
      setAlertType("warning");
    } else {
      const checkCitizenIdEncrypted = await encryptGCM({ value: citizenId });
      console.debug("Check Register Dupplicate");
      const payloadCheckDup = {
        citizenId: checkCitizenIdEncrypted.encrypted,
      };
      const resCheckDup = await checkDupEarthQuake(payloadCheckDup);
      if (resCheckDup.status_flag && resCheckDup.count.check_dup <= 0) {
        var accountList = "";
        var resAddRegisterFlag = false;
        var resAddRegisterMsg = "";
        var cidRegList = [];
        if (custType === "บุคคลธรรมดา") {
          const citizenIdEncrypted = await encryptGCM({ value: citizenId });
          const laserCardIdEncrypted = await encryptGCM({ value: laserCardId });
          const nameEncrypted = await encryptGCM({ value: name });
          const surnameEncrypted = await encryptGCM({ value: surname });
          const telNoEncrypted = await encryptGCM({ value: telNo });

          const payloadVerifyLaserId = {
            citizenId: citizenIdEncrypted.encrypted,
            name: nameEncrypted.encrypted,
            surname: surnameEncrypted.encrypted,
            dateOfBirth: `${
              dateOfBirth.split("-")[0] + dateOfBirth.split("-")[1] + dateOfBirth.split("-")[2]
            }`,
            laserCardId: laserCardIdEncrypted.encrypted,
          };

          //Verify Laser Id Card
          console.debug(`Verify Laser Id Card`);
          const resVerifyLaserId = await verifyLaserId(payloadVerifyLaserId);
          if (resVerifyLaserId.status_flag) {
            console.debug(`VerifyLaserId Response Data : ${resVerifyLaserId}`);
            if (resVerifyLaserId.status_code === "0") {
              //Check Customer Target
              console.debug(`Verify Customer Target`);
              const payloadCheckCustTarget = {
                citizenId: citizenIdEncrypted.encrypted,
                digitNo: digitNo,
              };
              const resCheckCustTarget = await findCustTargetByCitizenIdAndCifNo(
                payloadCheckCustTarget
              );
              if (resCheckCustTarget.status_flag) {
                for (let index = 0; index < resCheckCustTarget.data_list.length; index++) {
                  if (index === 0) {
                    accountList +=
                      resCheckCustTarget.data_list[index].account_no.substring(0, 4) +
                      "xxxx" +
                      resCheckCustTarget.data_list[index].account_no.substring(8);
                  } else {
                    accountList += `, ${
                      resCheckCustTarget.data_list[index].account_no.substring(0, 4) +
                      "xxxx" +
                      resCheckCustTarget.data_list[index].account_no.substring(8)
                    }`;
                  }

                  let payloadAddRegister = {
                    citizenId: citizenIdEncrypted.encrypted,
                    laserCardId: laserCardIdEncrypted.encrypted,
                    cifNo: resCheckCustTarget.data_list[index].cif_no,
                    accountNo: resCheckCustTarget.data_list[index].account_no,
                    name: nameEncrypted.encrypted,
                    surname: surnameEncrypted.encrypted,
                    dateOfBirth: dateOfBirth,
                    telNo: telNoEncrypted.encrypted,
                    homeNo: homeNo,
                    road: road,
                    subDistrict: subDistrict,
                    district: district,
                    province: province,
                    postCode: postCode,
                    isCustTarget: true,
                    debtRepaymentCode: resCheckCustTarget.data_list[0].debt_repayment_code,
                  };
                  let resAddRegister = await addRegister(payloadAddRegister);
                  resAddRegisterFlag = resAddRegister.status_flag;
                  resAddRegisterMsg = resAddRegister.status_message;
                  let cid = {
                    cid: resCheckCustTarget.data_list[index].account_no,
                  };
                  cidRegList.push(cid);
                }

                if (resAddRegisterFlag) {
                  let payload = {
                    cidRegList,
                  };
                  const res = await exportCidToDebtTracking(payload);
                  if (res.status_flag) {
                    setIsLoading(false);
                    navigate("/ndrs/result", {
                      state: {
                        consentFlag: props.consentFlag,
                        isCustGsb: true,
                        isCustTarget: true,
                        debtRepaymentDesc: resCheckCustTarget.data_list[0].debt_repayment_name,
                        custType: custType,
                        isDupplicate: false,
                        accountNo: accountList,
                      },
                    });
                  } else {
                    setIsAlert(true);
                    setAlertMsg("ทำรายการไม่สำเร็จ กรุณาติดต่อสาขา");
                    setAlertType("error");
                    console.error(res.status_message);
                  }
                } else {
                  setIsLoading(false);
                  setIsAlert(true);
                  setAlertMsg(resAddRegisterMsg);
                  setAlertType("error");
                }
              } else {
                setIsLoading(false);
                if (resCheckCustTarget.status_message === "Target Not Found.") {
                  setIsAlert(true);
                  setAlertMsg("บัญชีสินเชื่อของท่านไม่ได้รับสิทธิ์เข้าร่วมมาตรการ");
                  setAlertType("warning");
                } else if (resCheckCustTarget.status_message === "Verifyied Number is incorrect.") {
                  setIsAlert(true);
                  setAlertMsg("กรุณาระบุรหัสตัวเลข 4 ตัวที่ได้รับจากธนาคาร ให้ถูกต้อง");
                  setAlertType("warning");
                } else {
                  setIsAlert(true);
                  setAlertMsg(resCheckCustTarget);
                  setAlertType("error");
                }
              }
            } else {
              setIsLoading(false);
              setIsAlert(true);
              setAlertMsg("สถานะบัตรประจำตัวประชาชน :" + resVerifyLaserId.status_message);
              setAlertType("warning");
            }
          } else {
            setIsLoading(false);
            setIsAlert(true);
            setAlertMsg("ไม่สามารถตรวจสอบสถานะบัตรประจำตัวประชาชนได้");
            setAlertType("warning");
            console.error(resVerifyLaserId.status_message);
          }
        } else if (custType === "นิติบุคคล") {
          const citizenIdEncrypted = await encryptGCM({ value: citizenId });
          const laserCardIdEncrypted = await encryptGCM({ value: laserCardId ? laserCardId : "-" });
          const nameEncrypted = await encryptGCM({ value: name });
          const surnameEncrypted = await encryptGCM({ value: surname ? surname : "-" });
          const telNoEncrypted = await encryptGCM({ value: telNo });

          //Check Customer Target
          console.debug("Verify Customer Target");
          const payloadCheckCustTarget = {
            citizenId: citizenIdEncrypted.encrypted,
            digitNo: digitNo,
          };
          const resCheckCustTarget = await findCustTargetByCitizenIdAndCifNo(
            payloadCheckCustTarget
          );
          if (resCheckCustTarget.status_flag) {
            for (let index = 0; index < resCheckCustTarget.data_list.length; index++) {
              if (index === 0) {
                accountList +=
                  resCheckCustTarget.data_list[index].account_no.substring(0, 4) +
                  "xxxx" +
                  resCheckCustTarget.data_list[index].account_no.substring(8);
              } else {
                accountList += `, ${
                  resCheckCustTarget.data_list[index].account_no.substring(0, 4) +
                  "xxxx" +
                  resCheckCustTarget.data_list[index].account_no.substring(8)
                }`;
              }

              let payloadAddRegister = {
                citizenId: citizenIdEncrypted.encrypted,
                laserCardId: laserCardIdEncrypted.encrypted,
                cifNo: resCheckCustTarget.data_list[index].cif_no,
                accountNo: resCheckCustTarget.data_list[index].account_no,
                name: nameEncrypted.encrypted,
                surname: surnameEncrypted.encrypted,
                dateOfBirth: dateOfBirth ? dateOfBirth : "-",
                telNo: telNoEncrypted.encrypted,
                homeNo: homeNo,
                road: road,
                subDistrict: subDistrict,
                district: district,
                province: province,
                postCode: postCode,
                isCustTarget: true,
                debtRepaymentCode: resCheckCustTarget.data_list[0].debt_repayment_code,
              };

              let resAddRegister = await addRegister(payloadAddRegister);
              resAddRegisterFlag = resAddRegister.status_flag;
              resAddRegisterMsg = resAddRegister.status_message;
              let cid = {
                cid: resCheckCustTarget.data_list[index].account_no,
              };
              cidRegList.push(cid);
            }

            if (resAddRegisterFlag) {
              let payload = {
                cidRegList,
              };
              const res = await exportCidToDebtTracking(payload);
              if (res.status_flag) {
                setIsLoading(false);
                navigate("/ndrs/result", {
                  state: {
                    consentFlag: props.consentFlag,
                    isCustGsb: true,
                    isCustTarget: true,
                    debtRepaymentDesc: resCheckCustTarget.data_list[0].debt_repayment_name,
                    custType: custType,
                    isDupplicate: false,
                    accountNo: accountList,
                  },
                });
              } else {
                setIsAlert(true);
                setAlertMsg("ท่านทำรายการไม่สำเร็จ กรุณาติดต่อสาขา");
                setAlertType("error");
                console.error(res.status_message);
              }
            } else {
              setIsLoading(false);
              setIsAlert(true);
              setAlertMsg(resAddRegisterMsg);
              setAlertType("error");
            }
          } else {
            setIsLoading(false);
            if (resCheckCustTarget.status_message === "Target Not Found.") {
              setIsAlert(true);
              setAlertMsg("บัญชีสินเชื่อของท่านไม่ได้รับสิทธิ์เข้าร่วมมาตรการ");
              setAlertType("warning");
            } else if (resCheckCustTarget.status_message === "Verifyied Number is incorrect.") {
              setIsAlert(true);
              setAlertMsg("กรุณาระบุรหัสตัวเลข 4 ตัวที่ได้รับจากธนาคาร ให้ถูกต้อง");
              setAlertType("warning");
            } else {
              setIsAlert(true);
              setAlertMsg(resCheckCustTarget);
              setAlertType("error");
            }
          }
        } else {
          setIsLoading(false);
          setIsAlert(true);
          setAlertMsg("กรุณาเลือกประเภทบุคคล");
          setAlertType("warning");
        }
      } else if (resCheckDup.status_flag && resCheckDup.count.check_dup > 0) {
        setIsLoading(false);
        navigate("/ndrs/result", {
          state: {
            consentFlag: props.consentFlag,
            isCustGsb: false,
            isCustTarget: false,
            debtRepaymentDesc: "",
            custType: custType,
            isDupplicate: true,
            accountNo: "",
          },
        });
      } else {
        setIsLoading(false);
        setIsAlert(true);
        setAlertMsg(resCheckDup.status_message);
        setAlertType("error");
      }
    }
  };
  return (
    <MKBox component="section" py={{ xs: 6, sm: 12 }}>
      <Container>
        {isAlert ? (
          <>
            <MKAlert color={alertType} dismissible>
              {alertMsg}
            </MKAlert>
            <br />
          </>
        ) : null}
        <Grid container item xs={12} justifyContent="center">
          <MKTypography variant="h5" color="primary" justifyContent="center">
            ระบุข้อมูลสำหรับการลงทะเบียน
          </MKTypography>
          <Grid container justifyContent="center" py={2} spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                ประเภทบุคคล
              </MKTypography>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={custType}
                  onChange={handleChangeCustType}
                >
                  <FormControlLabel value="บุคคลธรรมดา" control={<Radio />} label="บุคคลธรรมดา" />
                  <FormControlLabel value="นิติบุคคล" control={<Radio />} label="นิติบุคคล" />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                เลขบัตรประชาชน / เลขนิติบุคคล
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุเลขบัตรประชาชน / เลขนิติบุคคล"
                onChange={handleChangeCitizenId}
                value={citizenId}
                error={validCitizenId}
                autoComplete="off"
                fullWidth
                required
              />
              {validCitizenId ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุเลขบัตรประชาชน / เลขนิติบุคคลให้ถูกต้อง หรือครบถ้วน
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                เลขหลังบัตรประชาชน (กรณีประเภทบุคคลธรรมดา)
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุเลขหลังบัตรประชาชน (ไม่ต้องระบุ - )"
                onChange={handleChangeLaserCardId}
                value={laserCardId}
                error={validLaserCardId}
                autoComplete="off"
                fullWidth
              />
              {validLaserCardId ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุเลขหลังบัตรประชาชนให้ถูกต้อง หรือครบถ้วน (12 หลัก)
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                ชื่อ
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุชื่อ"
                onChange={handleChangeName}
                value={name}
                error={validName}
                autoComplete="off"
                fullWidth
                required
              />
              {validName ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุชื่อให้ถูกต้อง
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                นามสกุล (กรณีประเภทบุคคลธรรมดา)
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุนามสกุล"
                onChange={handleChangeSurname}
                value={surname}
                error={validSurname}
                autoComplete="off"
                fullWidth
                required
              />
              {validSurname ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุนามสกุลให้ถูกต้อง
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                วัน/เดือน/ปี (พ.ศ.) เกิด (กรณีประเภทบุคคลธรรมดา)
              </MKTypography>
              <DatePickerCustoms
                value={dateOfBirth}
                onChange={(christDate, buddhistDate) => {
                  setDateOfBirth(buddhistDate);
                  setValidBirthDay(validDate(buddhistDate, "YYYY-MM-DD"));
                }}
                placeholder={"ระบุ วัน/เดือน/ปี (พ.ศ.) เกิด"}
                dateFormat={"yyyy-MM-dd"}
                displayFormat={"DD MMMM YYYY"}
                clearable={true}
                disabled={false}
                readOnly={false}
                yearBoundary={99}
                autoComplete="off"
              />
              {validBirthtDay ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุ วัน/เดือน/ปี (พ.ศ.) เกิด ให้ถูกต้อง
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} hidden={true}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                บ้านเลขที่
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุบ้านเลขที่"
                onChange={handleChangeHomeNo}
                value={homeNo}
                error={validHomeNo}
                autoComplete="off"
                fullWidth
                required
              />
              {validHomeNo ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุบ้านเลขที่
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} hidden={true}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                ถนน
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุถนน (ไม่มีให้ระบุ - )"
                onChange={handleChangeRoad}
                value={road}
                error={validRoad}
                autoComplete="off"
                fullWidth
                required
              />
              {validRoad ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุถนน (ไม่มีให้ระบุ - )
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} hidden={true}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                แขวง/ตำบล
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุแขวง/ตำบล"
                onChange={handleChangeSubDistrict}
                value={subDistrict}
                error={validSubDistrict}
                autoComplete="off"
                fullWidth
                required
              />
              {validSubDistrict ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุแขวง/ตำบล
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} hidden={true}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                เขต/อำเภอ
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุเขต/อำเภอ"
                onChange={handleChangeDistrict}
                value={district}
                error={validDistrict}
                autoComplete="off"
                fullWidth
                required
              />
              {validDistrict ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุเขต/อำเภอ
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} hidden={true}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                จังหวัด
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุจังหวัด"
                onChange={handleChangeProvince}
                value={province}
                error={validProvince}
                autoComplete="off"
                fullWidth
                required
              />
              {validProvince ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุจังหวัด
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} hidden={true}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                รหัสไปรษณีย์
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุรหัสไปรษณีย์"
                onChange={handleChangePostCode}
                value={postCode}
                error={validPostCode}
                autoComplete="off"
                fullWidth
                required
              />
              {validPostCode ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณารหัสไปรษณีย์ให้ถูกต้อง หรือครบถ้วน (5 หลัก)
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                เบอร์โทรติดต่อ
              </MKTypography>
              <MKInput
                type="tel"
                color="primary"
                label="ระบุเบอร์โทรติดต่อ"
                onChange={handleChangeTelNo}
                value={telNo}
                error={validTelNo}
                autoComplete="off"
                fullWidth
                required
              />
              {validTelNo ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาเบอร์โทรติดต่อให้ถูกต้อง หรือครบถ้วน (10 หลัก)
                </MKTypography>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <MKTypography variant="body2" fontWeight="regular" color="dark">
                รหัสตัวเลข 4 ตัวที่ได้รับจากธนาคาร
              </MKTypography>
              <MKInput
                type="text"
                color="primary"
                label="ระบุรหัสตัวเลข 4 ตัวที่ได้รับจากธนาคาร"
                onChange={handleChangeDigitNo}
                value={digitNo}
                error={validDigitNo}
                autoComplete="off"
                fullWidth
                required
              />
              {validDigitNo ? (
                <MKTypography variant="caption" fontWeight="medium" color="error">
                  กรุณาระบุเลขที่บัญชีเงินฝากธนาคารออมสิน 4 ตัวท้าย หรือ รหัสตัวเลข 4
                  ตัวที่ได้รับจากธนาคาร ให้ถูกต้อง
                </MKTypography>
              ) : null}
            </Grid>
          </Grid>
          <Grid container justifyContent="center" py={2}>
            <MKButton
              variant="contained"
              color="primary"
              onClick={handleConfirmRegister}
              disabled={
                validCitizenId ||
                validLaserCardId ||
                validName ||
                validSurname ||
                validBirthtDay ||
                validHomeNo ||
                validRoad ||
                validSubDistrict ||
                validDistrict ||
                validProvince ||
                validPostCode ||
                validTelNo ||
                validDigitNo ||
                isLoading
                  ? true
                  : false
              }
            >
              ยืนยันการลงทะเบียน
            </MKButton>
          </Grid>
          {isLoading ? (
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Stack sx={{ width: "50%" }}>
                  <LinearProgress color="primary" />
                </Stack>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Container>
    </MKBox>
  );
}

FormInformation.defaultProps = {
  consentFlag: false,
};
FormInformation.propTypes = {
  consentFlag: PropTypes.bool.isRequired,
};
export default FormInformation;
